(function () {
  // Défère l'init des carrousels bien sous la ligne de flottaison. Chaque slider du thème est un
  // custom element dont le constructeur appelle this.init() -> new Swiper(). On enveloppe init()
  // pour qu'il ne tourne qu'une fois le carrousel proche du viewport.
  //
  // Deux garde-fous contre les régressions visuelles :
  //  - on n'effleure JAMAIS les sliders d'entête / pied / overlays (search, menu, drawer, modal,
  //    popup) : ils s'initialisent alors qu'ils sont display:none, or un IntersectionObserver ne
  //    se déclenche pas sur un élément sans boîte -> ils resteraient morts à l'ouverture.
  //  - tout slider déjà visible (ou à moins de 300px du bas de l'écran) au moment de l'init
  //    démarre tout de suite : le hero et le haut de page ne changent pas d'un poil.
  if (!('customElements' in window) || !('IntersectionObserver' in window)) return;

  var defer = {
    'collection-slider': 1, 'collection-swiper-slider': 1, 'grid-slider': 1,
    'multi-slider': 1, 'blog-slider': 1, 'insta-slider': 1, 'recommendation-slider': 1,
    'support-slider': 1, 'team-slider': 1, 'brand-slider': 1, 'flex-slider': 1,
    'page-slider': 1, 'featured-swiper-slider': 1, 'swiper-slider': 1,
    'testimonial-slider': 1, 'image-with-text-slider': 1
  };
  // slideshow-component (hero) volontairement exclu : reste immédiat.

  var SKIP = '[id^="shopify-section-header"], [id*="footer"], header, footer,' +
    ' details-overlay-modal, dialog, [class*="modal"], [class*="drawer"],' +
    ' [class*="popup"], [class*="header__"], [class*="menu-drawer"]';

  var nativeDefine = customElements.define;
  customElements.define = function (name, ctor, options) {
    try {
      if (defer[name] && ctor && ctor.prototype && typeof ctor.prototype.init === 'function') {
        var nativeInit = ctor.prototype.init;
        ctor.prototype.init = function () {
          var el = this;
          // Entête / pied / overlays cachés : init immédiate comme avant, jamais différée.
          if (el.closest && el.closest(SKIP)) { return nativeInit.call(el); }
          var vh = window.innerHeight || document.documentElement.clientHeight || 0;
          var r = el.getBoundingClientRect();
          // Déjà (presque) à l'écran : init synchrone, aucun flash.
          if (r.width > 0 && r.height > 0 && r.top < vh + 300) { return nativeInit.call(el); }
          var io = new IntersectionObserver(function (entries, obs) {
            for (var i = 0; i < entries.length; i++) {
              if (entries[i].isIntersecting) { obs.disconnect(); nativeInit.call(el); return; }
            }
          }, { rootMargin: '600px 0px' });
          if (el.isConnected) io.observe(el);
          else requestAnimationFrame(function () { io.observe(el); });
        };
      }
    } catch (e) { /* en cas de souci, on retombe sur le define natif intact */ }
    return nativeDefine.call(customElements, name, ctor, options);
  };
})();
